import { ETHNICITY_OPTIONS } from '../ETHNICITY_OPTIONS';
import { EthnicityOptionIdType } from '../types';

const DEFAULT: EthnicityOptionIdType = 'european';

export const getEthnicityIdByTitle = (
  title: string | null | undefined,
  withDefault = false,
): EthnicityOptionIdType | null => {
  const id = ETHNICITY_OPTIONS.find((option) => option.title === title)?.id;

  if (id) {
    return id;
  }

  if (withDefault) {
    return DEFAULT;
  }

  return null;
};
